module.exports = __webpack_public_path__ + "img/CHEVRON_LEFT.ea4a8eb4.svg";